import Modal from "@components/ModalTemplate";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import "./style.scss";
import SectionHeader from "../SectionHeader";
import { useState } from "react";
import Switch from "@components/Switch";
import Button from "@components/Button";
import GloBanner from "./img/glo-banner.webp";
import VuseBanner from "./img/vuse-banner.webp";
import { useNavigate } from "react-router";
import {
  DETAILS_REFETCH_INVERVAL,
  getUserDetails,
  userDetailsUpdate,
} from "../../api/consumer";
import { useQuery, useQueryClient } from "@tanstack/react-query";

const WelcomeBrandsModal = NiceModal.create(() => {
  const modal = useModal();
  const [brands, setBrands] = useState(["vuse", "glo"]);
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [isBlurred, setIsBlurred] = useState(false);

  const dataQuery = useQuery({
    queryKey: ["user-details"],
    queryFn: getUserDetails,
    refetchInterval: DETAILS_REFETCH_INVERVAL,
  });

  const handleDataRefresh = () => {
    setIsBlurred(true);
    dataQuery.refetch().then(() => {
      queryClient.invalidateQueries(["homepage-coupons-list"]);
      queryClient.invalidateQueries(["homepage-activities-list"]);
      queryClient.invalidateQueries(["story-list"]);
      queryClient.invalidateQueries(["dashboard-slider"]);

      setTimeout(() => {
        setIsBlurred(false);
      }, 2500);
    });
  };

  const handleToggleBrand = (brand) => {
    setBrands((prevBrands) => {
      if (prevBrands?.includes(brand)) {
        if (prevBrands.length === 1) {
          return prevBrands;
        }
        const updatedBrands = prevBrands.filter((b) => b !== brand);
        userDetailsUpdate(
          {
            consumer: {
              brands: updatedBrands,
            },
          },
          () => {
            handleDataRefresh();
          }
        );
        return updatedBrands;
      } else {
        const updatedBrands = [...prevBrands, brand];
        userDetailsUpdate(
          {
            consumer: {
              brands: updatedBrands,
            },
          },
          () => {
            handleDataRefresh();
          }
        );
        return updatedBrands;
      }
    });
  };

  return (
    <Modal
      isOpen={modal.visible}
      onClose={() => {
        modal.hide();
        userDetailsUpdate(
          {
            consumer: {
              brands: brands,
            },
          },
          () => {
            handleDataRefresh();
          }
        );
      }}
      onAfterClose={() => modal.remove()}
      innerClass={`${isBlurred ? "active-blur" : ""} welcome-brands-modal`}
      disableClose
    >
      <SectionHeader>
        Willkommen im <strong>Inspiration Club!</strong>
      </SectionHeader>
      <p>
        <strong>
          Um den Inspiration Club zu nutzen, wähle die Marken aus, die dich am
          meisten interessieren.
        </strong>{" "}
        Und dann entdecke mit uns die wichtigsten ProgrammPunkte!
      </p>
      <div className="checkboxes-wrapper">
        <SectionHeader>
          <strong>An welchen Marken</strong> bist du interessiert?
        </SectionHeader>
        <div className="checkboxes">
          <div className="checkbox-wrapper">
            <div className="img-wrapper">
              <img src={GloBanner} alt="GloBanner" />
            </div>
            <Switch
              checked={brands?.includes("glo")}
              label={
                "<strong>glo™</strong> -  ein alternatives Gerät, das dir die Möglichkeit bietet, aus einer breiten Palette an Sticks von veo™, neo™ und Lucky Strike zu wählen, die für glo™ entwickelt wurden."
              }
              onChange={() => handleToggleBrand("glo")}
              register={() => {}}
              name="glo™"
            />
          </div>
          <div className="checkbox-wrapper">
            <div className="img-wrapper">
              <img src={VuseBanner} alt="VuseBanner" />
            </div>
            <Switch
              checked={brands?.includes("vuse")}
              label={
                "<strong>Vuse</strong> - eine globale E-Zigarettenmarke, die eine Alternative zum traditionellen Rauchen bietet."
              }
              onChange={() => handleToggleBrand("vuse")}
              register={() => {}}
              name="Vuse"
            />
          </div>
        </div>
      </div>
      <p>
        Denke daran, dass du mehr als eine Marke auswählen und deine Präferenzen
        in deinem Profil jederzeit ändern kannst.
      </p>
      <Button
        action={() => {
          modal.hide();
          navigate("/?tutorial=true", { replace: true });
          userDetailsUpdate(
            {
              consumer: {
                brands: brands,
              },
            },
            () => {
              handleDataRefresh();
            }
          );
        }}
      >
        Entdecke den Inspiration Club
      </Button>
    </Modal>
  );
});

export default WelcomeBrandsModal;
